import { useEffect, useRef, useState } from 'react';
import styles from './dashboard.module.scss'


function Dashboard(props: any) {

  const inputRef = useRef<any>();
  const tryButtonRef = useRef<any>();
  const [toggle, setToggle] = useState(true);

  useEffect(() => {

    if (props.state.selected !== 'dashboard') {
        const clonedState = Object.assign({}, props.state);
        clonedState.selected = 'dashboard'
        props.stateChanger(clonedState);
    }
    return () => { }
  });

  useEffect(() => {
    return () => { }
  }, [toggle]);



  return (
    <div className={styles.container}>
      <p>Disable button using State</p>

      <input ref={inputRef} onChange={() => {
        if (inputRef.current.value === '')
          setToggle(true); else {

            
          setToggle(false);
          console.log(inputRef.current.value);

        }



      }} type="text"></input>
      <button ref={tryButtonRef} disabled={toggle} style={{ color: "red" }} onClick={() => { setToggle(true); console.log(inputRef.current.value) }}>Try</button>


    </div>
  );
}


export default Dashboard;